var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',_vm._b({attrs:{"value":_vm.dateValue,"type":_vm.type},on:{"input":function($event){return _vm.input($event)}}},'el-date-picker',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }